
import React from 'react';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';

const InterfacesCallToAction = () => {
  return (
    <section className="py-16 bg-blue-700">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center text-white">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">Bereit für nahtlos integrierte Systeme?</h2>
          <p className="text-lg text-blue-100 mb-8 max-w-2xl mx-auto">
            Lassen Sie uns gemeinsam eine maßgeschneiderte Schnittstellenlösung entwickeln, die Ihre Systeme optimal verbindet und Ihre Geschäftsprozesse beschleunigt.
          </p>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-lg mx-auto">
            <Button asChild size="lg" variant="default" className="bg-white text-blue-700 hover:bg-blue-50">
              <Link to="/about">Beratungsgespräch vereinbaren</Link>
            </Button>
            <Button asChild size="lg" variant="outline" className="border-white text-white hover:bg-blue-800">
              <Link to="/references">Erfolgsbeispiele ansehen</Link>
            </Button>
          </div>
          
          <div className="mt-12 flex items-center justify-center">
            <div className="bg-blue-800 rounded-full p-3">
              <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"></path>
              </svg>
            </div>
            <div className="ml-4 text-left">
              <p className="text-blue-200 text-sm">Oder rufen Sie uns direkt an</p>
              <p className="text-white font-bold">+49 (0) 123 456 789</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default InterfacesCallToAction;
